import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import i18n from 'scoreboard/components/i18n'
import onOffToggle from 'scoreboard/components/on-off-toggle.hbs'

var LockedToggle = BootslideMenu.ToggleProperty.extend({
	property: {
		name: 'locked',
		label: 'dashboards.lock'
	},

	render: function () {
		this.$el.html(BootslideMenu.configIconLabel('lock', this.property.label))
			.append(onOffToggle({
				name: this.property.name,
				checked: this.val()
			}))
		this.$('.on-off-toggle').addClass('toggle-mini')
		return this
	},

	updateModel: function () {
		var newVal = !this.val()

		this.canvas.selection.wobs.forEach(function (wob) {
			wob.set('locked', newVal)
		})

		this.trigger('done')
	}
})

function createLockedMenu (widgetModel, canvas) {
	return {
		label: i18n.get('dashboards.lock'),
		contentView: LockedToggle.extend({canvas: canvas}),
		model: widgetModel.wob
	}
}

export default createLockedMenu

createLockedMenu.__filename__ = 'dashboards/widgets/create-locked-menu.js'
